// extracted by mini-css-extract-plugin
module.exports = {"slide":"_9330de7794--slide--Ul8Fh"};